module.exports = __webpack_public_path__ + "img/农业大数据中心.9660aed6.png";